module.exports = __webpack_public_path__ + "e53c96cce8a7272e0ffec51d1eb35f56.pdf";